const equipmentInfo = {
  service: 'Service',
  companies: 'Companies',
  place: 'Place',
};

export default equipmentInfo;
